





















































/* eslint-disable */
import getUrlParam from '@/common/utils/getUrlParam';
import CONFIG from "@/common/config";


import { Component, Vue, Mixins } from "vue-property-decorator";
import PageInitialMixin from "@/mixins/PageInitialMixin";
import { Getter, Action } from "vuex-class";
import IndexInstitutionIntroList from "@/components/common/index/IndexInstitutionIntroList.vue";
import fetch from "@/common/api/fetch";
import ActivityInfo from './AcitivityInfo.vue'
import { IntroItem } from "@/common/interface";
import { replaceString } from "@/common/utils/dealWithString";
const loadingImage = require("@/assets/img/loadingImage.gif");
@Component({
  components: {
    "index-institution-intro-list": IndexInstitutionIntroList
  },
})
export default class InstInfo extends Vue {

  @Getter("contactQrcode") contactQrcode!: string;
  @Getter("title") title!: string;
  @Getter("instName") instName!: string;
  @Getter("deadline") deadline!: string;
  @Getter("activityRule") activityRule!: string;
  @Getter("instAddress") instAddress!: string;
  @Getter("instPhone") instPhone!: string;
  @Getter("institutionIntros") getterInstitutionIntros!: Array<IntroItem>;
  @Action("changeShowFooter") changeShowFooter!: Function;
    @Getter("section") section!: object;

  get institutionIntros(): Array<IntroItem> {
    const tempArray: Array<IntroItem> = [];
    for (
      let i: number = 0, length: number = this.getterInstitutionIntros.length;
      i < length;
      i++
    ) {
      const item: IntroItem = Object.assign(
        {},
        this.getterInstitutionIntros[i]
      );
      item.value = item.value && replaceString(item.value);
     
      tempArray.push(item);
    }
    return tempArray;
  }
loadingImage: string = loadingImage;

  created() {
  }
  mounted() {
  }
  get callPhone(): string {
    return "tel:" + this.instPhone;
  }
  hiddenKeyboard(evt: Event): void {
    (document.activeElement as HTMLElement).blur();
  }
  toKeepHeight() :void{
    var scroll:any = (document.getElementById('cover-scroll')||{}).scrollTop;
    sessionStorage.setItem('scroll',scroll);
  }
  handleVideo(item: any) {
    fetch.parseUrl(item.value).then((res: any) => {
      const query = {
        url: res || item.value
      };
      this.$router.push({
        name: "video",
        query: query
      });
    });
  }

  
}
